import { useMutation } from '@tanstack/react-query';

import { makeAuthenticatedPostRequest } from '../../../services/axios';
import { screeningInterestFormSubmit } from '../../../services/axios/endpoints';

export default function useSubmitScreeningInterest() {
  return useMutation({
    mutationFn: async () => {
      const response = await makeAuthenticatedPostRequest(screeningInterestFormSubmit);
      return response?.data;
    },
  });
}
